<template>
  <v-menu offset-y light nudge-bottom="9" nudge-left="124" max-width="300" max-height="300" class="z4">
    <template #activator="{ on }">
      <v-btn icon color="white"  :disabled="!notifications.length" v-on="on">
        <v-icon>mdi-bell-badge-outline</v-icon>
      </v-btn>
    </template>
    <v-list class="py-1">
      <template v-if="notifications.length" v-for="(notification, index) in notifications">
        <v-divider v-if="index !== 0" />
        <v-list-item @click="buttonAction(notification)" class="px-1">
          <v-list-item-icon class="align-self-center mx-3">
            <v-icon :color="notification.typeIconColor" size="24" >{{ notification.typeIcon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-wrap text-body-2">{{ notification.description }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { computed } from '@vue/composition-api';
import { format, fromUnixTime } from 'date-fns';
import store from '@/store';
import { EventBus, sendNotification, isSessionOverlapping } from '@/helpers/utils';

export default {
  name: 'Notifications',
  setup () {
    const dailySessions = computed(() => store.getters.dailySessions);
    const dailySoins = computed(() => store.getters.dailySoins);

    const notifications = computed(() => {
      const items = [];
      const processedOverlaps = new Set();

      dailySoins.value.forEach(soin => {
        items.push({
          id: soin.id,
          description: `Un soin est prévu aujourd'hui pour ${(soin.horses || []).length} chevaux.`,
          type: 'Soins',
          typeIcon: 'mdi-medical-bag',
          typeIconColor: 'third'
        })
      });

      dailySessions.value.forEach(session => {
        (session.horses || []).filter(hs => hs.uuid).forEach(horse => {
          const otherSessions = dailySessions.value.filter(s => s.id !== session.id && (s.horses || []).some(h => h.uuid === horse.uuid));
          
          otherSessions.forEach(otherSession => {
            if (isSessionOverlapping(session, otherSession)) {
              const overlapKey = [session.id, otherSession.id, horse.uuid].sort().join('-');
              
              if (!processedOverlaps.has(overlapKey)) {
                processedOverlaps.add(overlapKey);
                const horseName = horse.horse_name || horse.wtitle || 'Inconnu';
                const earliestStart = Math.min(session.start_time, otherSession.start_time);
                const latestEnd = Math.max(session.end_time, otherSession.end_time);
                
                items.push({
                  id: overlapKey,
                  description: `Le cheval '${horseName}' est assigné à 2 sessions qui se chevauchent. (${format(fromUnixTime(earliestStart), 'HH:mm')} - ${format(fromUnixTime(latestEnd), 'HH:mm')})`,
                  type: 'Overlap',
                  typeIcon: 'mdi-alert',
                  typeIconColor: 'warning',
                  sessionId: session.id
                });
              }
            }
          });
        });
      });

      return items;
    });

    const buttonAction = (item) => {
      switch (item.type) {
        case 'Soins':
          const soinSession = dailySoins.value.find(soin => soin.id === item.id);
          EventBus.$emit('showEditSession', { session: soinSession });
          break;
      
        default:
          sendNotification('error', 'Action non disponible!');
          break;
      }
    };

    return { notifications, buttonAction };
  }
};
</script>